///////////////////////////////
// class of helper functions //
///////////////////////////////

helper = (function () {
  function getSymbolChildrenDescriptions(symbolID) {
    var description = [];
    var symbols = resourceManager.getConfiguration().symbols;

    // Boards for all fruits
    // if (symbolID === symbols.Coconut.ID || symbolID === symbols.Pineapple.ID || symbolID === symbols.WaterMelon.ID || symbolID === symbols.Orange.ID || symbolID === symbols.Kiwi.ID) {
    // 	description.push( { "name": "board1", "type": "sprite", "json": { "fileName": "Symbols/Fruits/board1.png", "anchor": 0.5, x:-95, y:0} } );
    // 	description.push( { "name": "board2", "type": "sprite", "json": { "fileName": "Symbols/Fruits/board2.png", "anchor": 0.5, x:-33, y:0} } );
    // 	description.push( { "name": "board3", "type": "sprite", "json": { "fileName": "Symbols/Fruits/board3.png", "anchor": 0.5, x:30, y:0} } );
    // 	description.push( { "name": "board4", "type": "sprite", "json": { "fileName": "Symbols/Fruits/board4.png", "anchor": 0.5, x:90, y:0} } );
    // }

    // Symbols
    switch (symbolID) {
      case symbols.Jack.ID:
        {
          description.push({
            name: 'fruit',
            type: 'sprite',
            json: {
              fileName: 'Symbols/J/J_0000.png',
              anchor: 0.5,
              x: 0,
              y: 0,
            },
          });
          description.push({
            name: 'glow',
            type: 'sprite',
            json: {
              fileName: 'Symbols/J/J_0000.png',
              anchor: 0.5,
              x: 0,
              y: 0,
              alpha: 0,
            },
          });
        }
        break;

      case symbols.Queen.ID:
        {
          description.push({
            name: 'fruit',
            type: 'sprite',
            json: {
              fileName: 'Symbols/Q/Q_0000.png',
              anchor: 0.5,
              x: 0,
              y: 0,
            },
          });
          description.push({
            name: 'glow',
            type: 'sprite',
            json: {
              fileName: 'Symbols/Q/Q_0000.png',
              anchor: 0.5,
              x: 0,
              y: 0,
              alpha: 0,
            },
          });
        }
        break;

      case symbols.King.ID:
        {
          description.push({
            name: 'fruit',
            type: 'sprite',
            json: {
              fileName: 'Symbols/K/K_0000.png',
              anchor: 0.5,
              x: 0,
              y: 0,
            },
          });
          description.push({
            name: 'glow',
            type: 'sprite',
            json: {
              fileName: 'Symbols/K/K_0000.png',
              anchor: 0.5,
              x: 0,
              y: 0,
              alpha: 0,
            },
          });
        }
        break;

      case symbols.Ace.ID:
        {
          description.push({
            name: 'fruit',
            type: 'sprite',
            json: {
              fileName: 'Symbols/A/A_0000.png',
              anchor: 0.5,
              x: 0,
              y: 0,
            },
          });
          description.push({
            name: 'glow',
            type: 'sprite',
            json: {
              fileName: 'Symbols/A/A_0000.png',
              anchor: 0.5,
              x: 0,
              y: 0,
              alpha: 0,
            },
          });
        }
        break;

      case symbols.HorseShoe.ID:
        {
          description.push({
            name: 'fruit',
            type: 'sprite',
            json: {
              fileName: 'Symbols/Statics/Symbol_Horseshoe.png',
              anchor: 0.5,
              x: 0,
              y: 0,
            },
          });
          description.push({
            name: 'glow',
            type: 'sprite',
            json: {
              fileName: 'Symbols/Statics/Symbol_Horseshoe.png',
              anchor: 0.5,
              x: 0,
              y: 0,
              alpha: 0,
            },
          });
        }
        break;

      case symbols.Hat.ID:
        {
          // description.push( { "name": "surround", "type": "sprite", "json": { "fileName": "Symbols/Tiki/BlueTikiFrame.png", "anchor": 0.5, x:0, y:0} } );
          description.push({
            name: 'mask',
            type: 'sprite',
            json: {
              fileName: 'Symbols/Statics/Symbol_Hat.png',
              x: 0,
              y: 0,
              anchor: 0.5,
            },
          });
          description.push({
            name: 'glow',
            type: 'sprite',
            json: {
              fileName: 'Symbols/Statics/Symbol_Hat.png',
              x: 0,
              y: 0,
              anchor: 0.5,
              alpha: 0,
            },
          });
        }
        break;

      case symbols.Pot.ID:
        {
          // description.push( { "name": "surround", "type": "sprite", "json": { "fileName": "Symbols/Tiki/RedTikiFrame.png", "anchor": 0.5, x:0, y:0} } );
          description.push({
            name: 'mask',
            type: 'sprite',
            json: {
              fileName: 'Symbols/Statics/Symbol_Pot.png',
              x: 0,
              y: 0,
              anchor: 0.5,
            },
          });
          description.push({
            name: 'glow',
            type: 'sprite',
            json: {
              fileName: 'Symbols/Statics/Symbol_Pot.png',
              x: 0,
              y: 0,
              anchor: 0.5,
              alpha: 0,
            },
          });
        }
        break;

      case symbols.Title.ID:
        {
          //  description.push( { "name": "surround", "type": "sprite", "json": { "fileName": "Symbols/Tiki/GreenTikiFrame.png", "anchor": 0.5, x:0, y:0} } );
          description.push({
            name: 'mask',
            type: 'sprite',
            json: {
              fileName: 'Symbols/Statics/Symbol_Title.png',
              x: 0,
              y: 0,
              anchor: 0.5,
            },
          });
          description.push({
            name: 'glow',
            type: 'sprite',
            json: {
              fileName: 'Symbols/Statics/Symbol_Title.png',
              x: 0,
              y: 0,
              anchor: 0.5,
              alpha: 0,
            },
          });
        }
        break;

      case symbols.Bonus.ID:
        {
          description.push({
            name: 'mask',
            type: 'sprite',
            json: {
              fileName: 'Symbols/Statics/Symbol_Bonus.png',
              x: 0,
              y: 0,
              anchor: 0.5,
            },
          });
          description.push({
            name: 'glow',
            type: 'sprite',
            json: {
              fileName: 'Symbols/Statics/Symbol_Bonus.png',
              x: 0,
              y: 0,
              anchor: 0.5,
              alpha: 0,
            },
          });
        }
        break;

      case symbols.Wild.ID:
        {
          description.push({
            name: 'mask',
            type: 'sprite',
            json: {
              fileName: 'Symbols/Statics/Symbol_Wild.png',
              x: 0,
              y: 0,
              anchor: 0.5,
            },
          });
          description.push({
            name: 'glow',
            type: 'sprite',
            json: {
              fileName: 'Symbols/Statics/Symbol_Wild.png',
              x: 0,
              y: 0,
              anchor: 0.5,
              alpha: 0,
            },
          });
        }
        break;
    }

    return description;
  }

  function symbolCreationCallback(reelIndex, symbolID, offset) {
    var childContainer = slotMachine.reels[reelIndex].symbolSprites[offset].children[0].children[0].children;
    var glow;
    if (childContainer.length > 0) {
      for (var i = 0; i < childContainer.length; i++) {
        if (childContainer[i].Props.ID.indexOf('glow') !== -1) {
          glow = childContainer[i];
          glow.blendMode = PIXI.BLEND_MODES.ADD;
        }
      }
    }
  }

  function updateHelpPageSymbols() {
    // Here we go through help pages and add children
    for (var i = 0; i < 9; i++) {
      var symbolName =
        'helpPageScroll:scrollArea:scrollContainer:paytables:paytableContainer:payTable' + (i + 1) + ':symbolGraphic';
      var symbol = resourceManager.get(symbolName);

      var childDescriptions = getSymbolChildrenDescriptions(i);
      for (j = 0; j < childDescriptions.length; j++) {
        var child = resourceManager.createObject(
          childDescriptions[j].type,
          childDescriptions[j].name,
          symbol.name,
          childDescriptions[j].json
        );
      }
    }
  }

  function displayCurveAsLine(start, end, containerName, step, P0, P3) {
    //curve visualisation as continuous line rather than points

    var startPos = InterpolationHelper.CatmullRom(P0, start, end, P3, 0);

    var endPos = {};

    for (var i = 0; i < 1; i += step) {
      endPos = InterpolationHelper.CatmullRom(P0, start, end, P3, i);

      var lineSeg = new PIXI.Graphics();

      lineSeg.lineStyle(2, 0x000000);
      lineSeg.moveTo(startPos.x, startPos.y);
      lineSeg.lineTo(endPos.x, endPos.y);
      lineSeg.endFill();

      startPos = endPos;

      resourceManager.getContainer(containerName).addChild(lineSeg);
    }
  }

  function linearInterpolate(P1, P2, delta) {
    var x = P1.x + (P2.x - P1.x) * delta;
    var y = P1.y + (P2.y - P1.y) * delta;

    return { x: x, y: y };
  }

  return {
    displayCurveAsLine: displayCurveAsLine,
    getSymbolChildrenDescriptions: getSymbolChildrenDescriptions,
    symbolCreationCallback: symbolCreationCallback,
    updateHelpPageSymbols: updateHelpPageSymbols,
    linearInterpolate: linearInterpolate,
  };
})();
